import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SessionState } from './session.state';
import { AuthState } from '../auth.state';
import { constants } from 'src/app/core/constants/globals';

const selectAuthState = createFeatureSelector('auth');

export const selectSessionState = createSelector(selectAuthState, (authState: AuthState) => authState.sessionState);

export const selectSessionLoading = createSelector(selectSessionState, (state: SessionState) => state.loading);

export const selectSessionUser = createSelector(selectSessionState, (state: SessionState) => state.user);

export const selectSessionLanguage = createSelector(selectSessionState, (state: SessionState) => {
  if (state.user && state.user.UILanguage) {
    return state.user.UILanguage;
  } else {
    return constants.uiDefaultLanguage;
  }
});

export const selectSessionLocale = createSelector(selectSessionState, (state: SessionState) => {
  if (state.UILocale !== '') {
    return state.UILocale;
  } else {
    return constants.uiDefaultLocale;
  }
});

export const selectIsAdmin = createSelector(selectSessionState, (state: SessionState) => state.user && state.user.Roles.includes('Admin'));

export const selectIsDeveloper = createSelector(
  selectSessionState,
  (state: SessionState) => state.user && state.user.Roles.includes('Developer')
);

const selectCurrentUser = createSelector(selectSessionState, state => state.user);

export const createSelectHasAnyOfRoles = (...roles: string[]) => {
  return createSelector(selectCurrentUser, user => {
    if (!user?.Roles) {
      return false;
    }

    return roles.some(role => user.Roles.includes(role));
  });
};

export const selectCanViewAndEditPrices = createSelectHasAnyOfRoles('Sales', 'Admin', 'Developer');
